<template>
  <div>

    <section class="content">
      <div class="box info-box">
        <div class="box-header with-border">
          Filter By
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
              <label for="Branch">Branch</label>
              <v-select v-model="branchDetail" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranchWiseRecord(branch)"></v-select>
              
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
      </div>

      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('areasurvey-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Area Survey List</h3>
          
          <div class="box-tools">
            <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('areasurvey-create')">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>Area Name</th>
                <th class="hidden-xs">Branch</th>
                <th class="hidden-xs">Survey Date</th>
                <th>Employee </th>
                <th class="hidden-xs">Status</th>
                <th>Action</th>

                <!-- <th v-if="$gate.isAdmin()">Status</th>
                <th>Image</th>
                <th v-if="$gate.isAdmin()">Modify</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows.data" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td>{{ row.areaName }}</td>
                <td class="hidden-xs">{{ row.branch.name }}</td>
                <td class="hidden-xs">{{ row.surveyDate | myDate }}</td>
                <td>{{ row.employee.name }}</td>
                <td class="hidden-xs">
                  {{row.status}}
                </td>
                <td>
                  <div class="btn-group dropup">
                    <button type="button" class="btn btn-flat btn-xs dropdown-toggle" data-toggle="dropdown">
                      Task <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" role="menu">
                      <li v-if="canAccess('areasurvey-view')">
                        <a @click="viewModal(row)">
                          <i class="fa fa-eye text-info"> View</i> 
                        </a>
                      </li>
                      <li v-if="canAccess('areasurvey-update')">
                        <a @click="editModal(row)">
                          <i class="fa fa-pencil-square text-primary"> Update</i>
                        </a>
                      </li>
                      <li v-if="canAccess('areasurvey-approve')">
                        <a @click="approveModel(row)">
                          <i class="fa fa-check-square text-success"> Approve</i> 
                        </a>
                      </li>
                      <li v-if="canAccess('areasurvey-delete')">
                        <a @click="deleteModal(row.id)">
                          <i class="fa fa-trash text-danger"> Delete</i> 
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->

    </section>

        <div class="modal fade" id="newModal">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 v-show="!editMode" class="modal-title">Add New</h4>
                <h4 v-show="editMode" class="modal-title">Update</h4>
              </div>
              <form @submit.prevent="editMode ? updateGroup() : createGroup()">
                <div class="modal-body">
                  <!-- right column -->
                    <!-- general form elements disabled -->
                    <div class="card card-warning">
                      <!-- /.card-header -->
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-6">
                            <!-- text input -->
                            <div class="form-group">
                              <label for="Branch">Branch</label>
                              <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranchWiseRecord(branch)"></v-select>
                            
                              <has-error
                                :form="form"
                                field="branch_id"
                              ></has-error>
                            </div>
                            <div class="form-group">
                                <label>
                                Survey Date
                                <span class="red">*</span></label
                                >
                                <input
                                v-model="form.surveyDate"
                                type="date"
                                name="surveyDate"
                                class="form-control"
                                :class="{
                                    'is-invalid': form.errors.has(
                                    'surveyDate'
                                    ),
                                }"
                                placeholder="Enter Survey Date"
                                required
                                />
                                <has-error
                                :form="form"
                                field="surveyDate"
                                ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Area Name <span class="red">*</span></label
                              >
                              <input
                                v-model="form.areaName"
                                type="text"
                                name="areaName"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('areaName'),
                                }"
                                required
                              />
                              <has-error :form="form" field="areaName"></has-error>
                            </div>
                            
                            <div class="form-group">
                              <label>Village Name <span class="red">*</span></label>
                              <input
                                v-model="form.villageName"
                                type="text"
                                name="villageName"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('villageName'),
                                }"
                                required
                              />
                              <has-error
                                :form="form"
                                field="villageName"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label>Population Of Villages</label> <span class="red">*</span>
                              <input
                                v-model="form.populationOfVillage"
                                type="text"
                                name="populationOfVillage"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('populationOfVillage'),
                                }"
                                required
                              />
                              <has-error :form="form" field="populationOfVillage"></has-error>
                            </div>
                            <div class="form-group">
                              <label>Political Situation</label> <span class="red">*</span>
                              <input
                                v-model="form.politicalSituation"
                                type="text"
                                name="politicalSituation"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('politicalSituation'),
                                }"
                                required
                              />
                              <has-error :form="form" field="politicalSituation"></has-error>
                            </div>
                            <div class="form-group">
                              <label>Law And Order Situation</label> <span class="red">*</span>
                              <input
                                v-model="form.lawAndOrderSituation"
                                type="text"
                                name="lawAndOrderSituation"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('lawAndOrderSituation'),
                                }"
                                required
                              />
                              <has-error :form="form" field="lawAndOrderSituation"></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >General Caste Percentage %
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.generalCastPercentage"
                                type="text"
                                name="generalCastPercentage"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'generalCastPercentage'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="generalCastPercentage"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >OBC Caste Percentage %
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.obcCastPercentage"
                                type="text"
                                name="obcCastPercentage"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'obcCastPercentage'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="obcCastPercentage"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >SC Caste Percentage %
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.scCastPercentage"
                                type="text"
                                name="scCastPercentage"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'scCastPercentage'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="scCastPercentage"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >ST Caste Percentage %
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.stCastPercentage"
                                type="text"
                                name="stCastPercentage"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'stCastPercentage'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="stCastPercentage"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Other Caste Percentage %
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.otherCastPercentage"
                                type="text"
                                name="otherCastPercentage"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'otherCastPercentage'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="otherCastPercentage"
                              ></has-error>
                            </div>
                          </div>

                          <div class="col-sm-6">
                            <div class="form-group">
                              <label
                                >Distance From Branch <span class="red">*</span></label
                              >
                              <input
                                v-model="form.distanceFromBranch"
                                type="text"
                                name="distanceFromBranch"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('distanceFromBranch'),
                                }"
                                required
                              />
                              <has-error :form="form" field="distanceFromBranch"></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Possible Center <span class="red">*</span></label
                              >
                              <input
                                v-model="form.possibleCenters"
                                type="text"
                                name="possibleCenters"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('possibleCenters'),
                                }"
                                required
                              />
                              <has-error :form="form" field="possibleCenters"></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >MFI Working <span class="red">*</span></label
                              >
                              <input
                                v-model="form.mfiWorking"
                                type="text"
                                name="mfiWorking"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('mfiWorking'),
                                }"
                                required
                              />
                              <has-error :form="form" field="mfiWorking"></has-error>
                            </div>
                            <div class="form-group">
                            <label
                              >MFI Name <span class="red">*</span></label
                            ><br>
                                <span v-for="(input,k) in form.mfiNames" :key="k" style="display: flex; flex-flow: row wrap;
                                  align-items: center;">
                                <input
                                  v-model="input.mfiNem"
                                  type="text"
                                  name="mfiNem"
                                  style="width:80% "
                                  class="form-control"
                                  placeholder="Micro Finance Name"
                                  :class="{
                                    'is-invalid': form.errors.has('mfiNem'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="mfiNem"
                                ></has-error>
                              
                                &nbsp;
                                  <span>
                                    <i class="fa fa-minus-circle btn-danger" @click="remove(k)" v-show="k || ( !k && form.mfiNames.length > 1)"></i>
                                    <i class="fa fa-plus-circle btn-success" @click="add(k)" v-show="k == form.mfiNames.length-1"></i>
                                  </span>
                                </span>
                                
                          </div>
                            <!-- <div class="form-group">
                              <label
                                >MFI Name <span class="red">*</span></label
                              >
                              <input
                                v-model="form.mfiNames"
                                type="text"
                                name="mfiNames"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('mfiNames'),
                                }"
                                required
                              />
                              <has-error :form="form" field="mfiNames"></has-error>
                            </div> -->
                            <div class="form-group">
                              <label
                                >Major Operation People
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.majorOperationPeople"
                                type="text"
                                name="majorOperationPeople"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'majorOperationPeople'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="majorOperationPeople"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Road Status
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.roadStatus"
                                type="text"
                                name="roadStatus"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'roadStatus'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="roadStatus"
                              ></has-error>
                            </div>

                            <div class="form-group">
                              <label
                                >Hindu Religion Percentage %
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.hinduReligionPercentage"
                                type="text"
                                name="hinduReligionPercentage"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'hinduReligionPercentage'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="hinduReligionPercentage"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Muslim Religion Percentage %
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.muslimReligionPercentage"
                                type="text"
                                name="muslimReligionPercentage"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'muslimReligionPercentage'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="muslimReligionPercentage"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Sikh Religion Percentage %
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.sikhReligionPercentage"
                                type="text"
                                name="sikhReligionPercentage"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'sikhReligionPercentage'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="sikhReligionPercentage"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Christian Religion Percentage %
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.christianReligionPercentage"
                                type="text"
                                name="christianReligionPercentage"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'christianReligionPercentage'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="christianReligionPercentage"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Other Religion Percentage %
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.otherReligionPercentage"
                                type="text"
                                name="otherReligionPercentage"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'otherReligionPercentage'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="otherReligionPercentage"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Remark</label
                              >
                              <input
                                v-model="form.remark"
                                type="text"
                                name="remark"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'remark'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="remark"
                              ></has-error>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  
                </div>
                <div class="modal-footer text-center">
                  <button
                    v-show="!editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    SAVE
                  </button>
                  <button
                    v-show="editMode"
                    type="submit"
                    class="btn btn-primary"
                  >
                    UPDATE
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <div class="modal fade" id="viewModal">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Area Survey Details</h4>
              </div>
              <div class="modal-body">
                <!-- right column -->
                <div class="row">
                  <div class="col-md-6">
                    <!-- Profile Image -->
                    <div class="card card-primary card-outline">
                      <div class="card-body box-profile">
                        <ul class="list-group mb-3">
                          <li class="list-group-item">
                            <b>Branch Name</b>
                              <a
                                class="pull-right"
                                v-if="record.branch"
                                >{{ record.branch.name }}</a
                              >
                          </li>
                          <li class="list-group-item">
                            <b>Employee Name</b>
                            <a class="pull-right" v-if="record.employee">{{ record.employee.name }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Approved Name</b>
                            <a class="pull-right" v-if="record.approved_by">{{ record.approved_by.name }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Hindu Religion (%)</b>
                            <a class="pull-right">{{ record.hinduReligionPercentage }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Muslim Religion (%)</b>
                            <a class="pull-right">{{ record.muslimReligionPercentage }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Sikh Religion (%)</b>
                            <a class="pull-right">{{ record.sikhReligionPercentage }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Christian Religion (%)</b>
                            <a class="pull-right">{{ record.christianReligionPercentage }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Other Religion (%)</b>
                            <a class="pull-right">{{ record.otherReligionPercentage }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>General Caste (%)</b>
                            <a class="pull-right">{{ record.generalCastPercentage }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>OBC Caste (%)</b>
                            <a class="pull-right">{{ record.obcCastPercentage }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>SC Caste (%)</b>
                            <a class="pull-right">{{ record.scCastPercentage }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>ST Caste (%)</b>
                            <a class="pull-right">{{ record.stCastPercentage }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Other Caste (%)</b>
                            <a class="pull-right">{{ record.otherCastPercentage }}</a>
                          </li>
                        </ul>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                  <div class="col-md-6">
                    <!-- Profile Image -->
                    <div class="card card-primary card-outline">
                      <div class="card-body box-profile">
                        <ul class="list-group mb-3">
                          <li class="list-group-item">
                            <b>Area Name</b>
                            <a class="pull-right">{{ record.areaName }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Village Name</b>
                            <a class="pull-right">{{ record.villageName }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Distance From Branch</b>
                            <a class="pull-right">{{ record.distanceFromBranch }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Road Status</b>
                            <a class="pull-right">{{ record.roadStatus }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Political Situation</b>
                            <a class="pull-right">{{ record.politicalSituation }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Low and Order Situation</b>
                            <a class="pull-right">{{ record.lawAndOrderSituation }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Major Operation People</b>
                            <a class="pull-right">{{ record.majorOperationPeople }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Possible Center</b>
                            <a class="pull-right">{{ record.possibleCenters }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>MFI Working</b>
                            <a class="pull-right">{{ record.mfiWorking }}</a>
                          </li>
                          <li class="list-group-item" v-if="mfinams">
                            <b>MFI Name </b>
                            <i class="" v-for="(mfinm, index) in mfinams" :key="index">
                              <br> {{index + 1}} - {{ mfinm.mfiNem }} 
                            </i>
                          </li>
                          <li class="list-group-item">
                            <b>Remark </b>
                            <a class="pull-right">{{ record.remark }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Status</b>
                            <a class="pull-right">{{ record.status }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Create Date</b>
                            <a class="pull-right">{{ record.created_at | myDate }}</a>
                          </li>
                        </ul>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                </div>
              </div>
              <div class="modal-footer text-center">
                <button
                  type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >
                  CLOSE
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->


  </div>
</template>

<script>
import { mapState } from 'vuex'
import GetBranch from '../../../mixins/BranchRecords'
import EmployeeRecord from '../../../mixins/EmployeeRecords'
export default {
  name: 'Groups',
  computed: {
    ...mapState([
      'user'
    ])
  },
  mixins: [GetBranch, EmployeeRecord],
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      form: new Form({
        id: '',
        branch_id: '',
        employee_id: '',
        approvedby_id: '',
        surveyDate: '',
        areaName: '',
        villageName: '',
        polulationOfVillage: '',
        politicalSituation: '',
        lawAndOrderSituation: '',
        distanceFromBranch: '',
        possibleCenters: '',
        mfiWorking: '',
        mfiNames: [ {
          mfiNem: ''
        }],
        majorOperationPeople: '',
        roadStatus: '',
        hinduReligionPercentage: '',
        muslimReligionPercentage: '',
        sikhReligionPercentage: '',
        christianReligionPercentage: '',
        otherReligionPercentage: '',
        generalCastPercentage: '',
        obcCastPercentage: '',
        scCastPercentage: '',
        stCastPercentage: '',
        otherCastPercentage: '',
        remark: '',
        status: ''
      }),
      editMode: false,
      mfinams: [],
      branches: [],
      branch: {},
      branch_id: '',
      branchDetail: {},
      staffs: [],
      staf: {},
      approvedby: {},
      collectionCenter: {},
      officers: {},
      rows: [],
      record: {},
      withChangeFilter: true
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    getBranchWiseRecord (branch) {
      this.form.branch_id = branch.id
      if (Object.keys(this.branch).length !== 0) {
        this.branchDetail = {}
        this.getEmployeeRecords()
      }
      if (Object.keys(this.branchDetail).length !== 0) {
        this.branch_id = this.branchDetail.id
        this.branch = {}
        this.changeFilter()
      }
    },
    employeeDetails (staff) {
      this.form.employee_id = staff.user_id
    },
    approvedByDetails (approvedby) {
      this.form.approvedby_id = approvedby.user_id
    },
    add (index) {
      this.form.mfiNames.push({mfiNem: ''})
    },
    remove (index) {
      this.form.mfiNames.splice(index, 1)
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      if (this.branch) {
        this.form.branch_id = this.branch.id
      }
      $('#newModal').modal({backdrop: 'static', keyboard: false})
    },
    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.mfiNames = JSON.parse(row.mfiNames)
      this.branch = row.branch
    },
    viewModal (row) {
      this.record = {}
      this.editMode = false
      this.form.reset()
      this.mfinams = JSON.parse(row.mfiNames)
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      // this.form.fill(row)
      this.record = row
    },
    approveModel (row) {
      this.form.fill(row)
      this.form.mfiNames = JSON.parse(row.mfiNames)
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to approve this survey !',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.isConfirmed) {
          this.form.status = 'Approved'
          this.$axios
            .put('areasurvey/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Approved!', 'Your Record has been Approved.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .delete('areasurvey/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    createGroup () {
      this.$axios
        .post('areasurvey', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Group Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: error.response.data.error })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    updateGroup () {
      this.$axios
        .put('areasurvey/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Group Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    changeFilter (page = null, pg = null) {
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'areasurvey'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (c.type !== 'admin') {
        if (c.role.name === 'Manager') {
          pageUrl += `&branch_id=${c.agent_profile.branch_id}`
        } else {
          pageUrl += `&agent_id=${c.id}`
        }
      }
      if (c.type === 'admin') {
        if (this.branch_id) {
          pageUrl += `&branch_id=${this.branch_id}`
        }
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          console.log(data)
          this.rows = data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    }
  },
  created () {
    // this.loadData()
    this.changeFilter()
    this.getBranch()
    Fire.$on('AfterCreate', () => {
      // this.loadData()
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.red {
  color: red;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// AreaSurvey.vue?81aad348